var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFestival(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 46,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M12.202 29.544v1.273c0 1.094.75 2.01 1.769 2.278v2.825c-1.03.394-1.782 1.387-1.782 2.558a2.74 2.74 0 0 0 2.736 2.736 2.732 2.732 0 0 0 .955-5.294V33.17h4.225v7.292c-1.031.394-1.782 1.387-1.782 2.557a2.74 2.74 0 0 0 2.736 2.736 2.732 2.732 0 0 0 .954-5.293V33.17h4.25v2.749c-1.03.394-1.78 1.387-1.78 2.558a2.74 2.74 0 0 0 2.735 2.736 2.74 2.74 0 0 0 2.736-2.736c0-1.171-.738-2.164-1.782-2.558v-2.825a2.338 2.338 0 0 0 1.77-2.278v-1.273c0-.636-.255-1.221-.675-1.641 3.474-3.78 5.026-7.559 4.632-11.224-.42-3.907-2.953-6.63-4.492-7.953.33-.407.534-.93.534-1.49V5.965A2.343 2.343 0 0 0 27.6 3.623h-5.561V1.345a.961.961 0 0 0-.955-.954.961.961 0 0 0-.954.954v2.252h-5.574a2.343 2.343 0 0 0-2.341 2.342V7.21c0 .56.203 1.082.534 1.49-1.54 1.323-4.072 4.046-4.492 7.953-.394 3.677 1.158 7.444 4.632 11.223a2.437 2.437 0 0 0-.687 1.667Zm8.87 14.291a.826.826 0 0 1-.828-.827c0-.458.37-.827.828-.827.458 0 .827.369.827.827a.826.826 0 0 1-.827.827Zm2.137-34.257c.573.738 1.948 2.724 2.635 5.383 1.132 4.403-.102 8.513-3.69 12.242h-2.19c-3.563-3.703-4.81-7.788-3.702-12.165.674-2.686 2.074-4.709 2.66-5.46h4.287ZM27.6 29.1a.43.43 0 0 1 .433.433v1.272a.43.43 0 0 1-.432.433H14.556a.43.43 0 0 1-.432-.433v-1.272a.43.43 0 0 1 .432-.433H27.6ZM14.939 39.292a.825.825 0 0 1-.827-.827c0-.458.369-.827.827-.827.458 0 .827.369.827.827a.825.825 0 0 1-.827.827Zm12.28 0a.825.825 0 0 1-.827-.827c0-.458.369-.827.827-.827.458 0 .827.369.827.827a.834.834 0 0 1-.827.827Zm4.785-22.41c.356 3.284-1.222 6.758-4.696 10.32h-2.596c3.881-4.81 3.818-9.492 2.99-12.712-.534-2.074-1.437-3.766-2.163-4.912h1.87c.879.624 4.15 3.258 4.595 7.305ZM14.11 5.953a.43.43 0 0 1 .433-.433h13.043a.43.43 0 0 1 .433.433v1.272a.43.43 0 0 1-.433.433h-13.03a.43.43 0 0 1-.433-.433V5.952h-.013Zm-3.97 10.943c.432-4.034 3.715-6.68 4.593-7.33h1.871c-.725 1.146-1.629 2.838-2.163 4.913-.827 3.22-.891 7.902 2.99 12.712h-2.596c-3.461-3.55-5.039-7.012-4.695-10.295Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M39.46 5.061a.961.961 0 0 0 .955-.954V2.949a.961.961 0 0 0-.955-.955.961.961 0 0 0-.954.955v1.158c0 .521.432.954.954.954Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M39.46 6.512a.961.961 0 0 0-.954.954v1.158c0 .522.432.955.954.955a.961.961 0 0 0 .955-.955V7.466a.953.953 0 0 0-.955-.954Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M36.634 6.74h1.158a.961.961 0 0 0 .954-.954.961.961 0 0 0-.954-.954h-1.158a.961.961 0 0 0-.954.954c0 .522.42.955.954.955Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M41.14 6.74h1.158a.961.961 0 0 0 .954-.954.961.961 0 0 0-.954-.954H41.14a.961.961 0 0 0-.955.954c0 .522.433.955.955.955Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#f)",
    d: "M4.67 28.922a.961.961 0 0 0 .954-.954V26.81a.961.961 0 0 0-.955-.954.961.961 0 0 0-.954.954v1.158c0 .534.42.954.954.954Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#g)",
    d: "M4.67 30.371a.961.961 0 0 0-.955.955v1.157c0 .522.433.955.954.955a.961.961 0 0 0 .955-.955v-1.157a.961.961 0 0 0-.955-.955Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#h)",
    d: "M1.831 30.6H2.99a.961.961 0 0 0 .955-.954.961.961 0 0 0-.955-.955H1.831a.961.961 0 0 0-.954.955c0 .521.433.954.954.954Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#i)",
    d: "M6.349 30.6h1.158a.961.961 0 0 0 .954-.954.961.961 0 0 0-.954-.955H6.349a.961.961 0 0 0-.954.955c0 .521.42.954.954.954Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 21.078,
    x2: 21.078,
    y1: 0.391,
    y2: 45.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2275A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FBD96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 39.46,
    x2: 39.46,
    y1: 1.994,
    y2: 5.061,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2275A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FBD96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 39.46,
    x2: 39.46,
    y1: 6.512,
    y2: 9.579,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2275A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FBD96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 37.213,
    x2: 37.213,
    y1: 4.832,
    y2: 6.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2275A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FBD96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 41.719,
    x2: 41.719,
    y1: 4.832,
    y2: 6.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2275A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FBD96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "f",
    x1: 4.669,
    x2: 4.669,
    y1: 25.855,
    y2: 28.922,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2275A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FBD96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "g",
    x1: 4.669,
    x2: 4.669,
    y1: 30.371,
    y2: 33.438,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2275A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FBD96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "h",
    x1: 2.41,
    x2: 2.41,
    y1: 28.691,
    y2: 30.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2275A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FBD96"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "i",
    x1: 6.928,
    x2: 6.928,
    y1: 28.691,
    y2: 30.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2275A1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4FBD96"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFestival);
export default __webpack_public_path__ + "static/media/festival.3591acb542b0af32224c971efc635e2a.svg";
export { ForwardRef as ReactComponent };